export default {
  ShowContacts: "showContacts",
  ShowLikedMe: "showLikedMe",
  ReadMessages: "readMessages",
  CreateVideoCall: "createVideoCall",
  SendLikeDislikePerDay: "sendLikeDislikePerDay",
};
